import * as Yup from 'yup';
import { getMaxValidation, getRequiredMessage } from 'views/declarations/utils/validation-utils';

export const emailTemplateValidationSchema = Yup.object({
    subject: getMaxValidation('subject', 255).required(getRequiredMessage('subject')).nullable(),
    body: getMaxValidation('body', 20000).required(getRequiredMessage('body')).nullable(),
    footer: getMaxValidation('footer', 10000).required(getRequiredMessage('footer')).nullable(),
});
